import { render } from "./GoalScoringStat.vue?vue&type=template&id=4f5d6c48"
import script from "./GoalScoringStat.vue?vue&type=script&lang=js"
export * from "./GoalScoringStat.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__